import React, { Component, Fragment } from 'react';
import common from 'ui-react-common';

const api = common.services.coreAPIInstance;
const { ScriptLoader, scripts } = common.ui.components.scriptLoader;
const { DeviceFingerprint } = common.ui.components.forms.configured;

class DeviceFingerprintConfigured extends Component {
    render() {
        return (
            <Fragment>
                <ScriptLoader scriptName={scripts.equifaxDeviceVerifyUi} api={api} />
                <DeviceFingerprint />
            </Fragment>
        );
    }
}

export default DeviceFingerprintConfigured;
